import React, {useEffect, useState} from 'react';
import {requestGetJobRequirementInfo} from "@app/services/JobService";
import {callApiSaveJob} from "@pages/job/common/Services";
import {CandidateDetailLanguageMode} from "@app/constants/Tabs";
import Select from "react-select";
import {JobServiceTypeOptions} from "@pages/job/common/Constant";
import {requestGetUserList} from "@app/services/UserService";
import {USER_ROLE} from "@app/constants/Common";

const SearchJobForAdContent = (props) => {
    const [searchInput, setSearchInput] = useState({});
    const [userOptions, setUserOptions] = useState([]);

    const {onChange, advanceSearchInput} = props

    const fetchUsers = async () => {
        const res = await requestGetUserList({});
        const userList = res.content.users
        const userOptionList = []
        userList.forEach(user => {
            if (user.groups && user.groups !== USER_ROLE.ADMIN) {
                userOptionList.push({value: user.id, label: user.email})
            }
        })
        setUserOptions(userOptionList);
    };

    useEffect(async () => {
        if (userOptions.length === 0) {
            await fetchUsers()
        }
    },[]);

    const onChangeSearchInputInfo = (fieldName, value) => {
        searchInput[fieldName] = value
        setSearchInput({...searchInput})
        if (onChange) {
            onChange(searchInput)
        }
    };

    useEffect(() => {
        setSearchInput(advanceSearchInput)
    }, [advanceSearchInput])

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>For Ad</h3>
            </div>
            <div className='card-body'>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Loại dịch vụ</label>
                    <div style={{width: '100%'}}>
                        <Select options={JobServiceTypeOptions}
                                value={searchInput.service_type}
                                onChange={value => {
                                    onChangeSearchInputInfo("service_type", value);
                                }}
                        />
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Note (Ad)</label>
                    <input type='text' className='form-control'
                           value={searchInput["note_ad"] ? searchInput["note_ad"] : ''}
                           name={"note_ad"}
                           onChange={event => onChangeSearchInputInfo("note_ad", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Users hide job</label>
                    <div style={{width: '100%'}}>
                        <Select options={userOptions}
                                isMulti
                                placeholder={"Chọn users"}
                                value={searchInput.hide_users}
                                onChange={values => {
                                    onChangeSearchInputInfo('hide_users', values);
                                }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchJobForAdContent;
